import {createAction, createAsyncThunk} from '@reduxjs/toolkit'

import {systemAlert} from '@web/actions/application'
import {addressBookApis as deliveryManagerApis} from '@web/actions/deliveryManager'
import {OrderSheetPageSetType} from '@web/core/constants'
import {AddressInfo} from '@web/slices/deliveryInfo/slice'

import apis, {DeprecatedZipCodes} from './apis'

/** 폐지된 우편번호 리스트 조회 */
export const getDeprecatedZipCodes = createAsyncThunk<DeprecatedZipCodes, OrderSheetPageSetType>(
    'getDeprecatedZipCodes',
    async (pageSet) => {
        const {orderDeprecateCodes} = await apis.fetchDeprecatedZipCodes(pageSet)

        return orderDeprecateCodes
    },
)

/** 배송지 등록 가능 여부 조회 */
export const getAddressAddible = createAsyncThunk<boolean, void>('getAddressAddible', async (_, {dispatch}) => {
    const {isAddible} = await deliveryManagerApis.getAddressBook()

    if (!isAddible) {
        dispatch(
            systemAlert({
                type: 'ALERT',
                message: '저장가능한 배송지 개수를 초과하였습니다. 배송지를 삭제하고 새로 등록해주세요.',
            }),
        )
    }

    return isAddible
})

/**
 * 배송지관리 screen/page를 여닫는 store값(shouldOpenAddressBook)을 업데이트
 * 배송지 feature에서 shouldOpenAddressBook 변경을 감지하여 배송지관리를 노출합니다.
 */
export const openAddressBook = createAction('deliveryManager/openAddressBook')
export const closeAddressBook = createAction('deliveryManager/closeAddressBook')

/** 배송지 업데이트 */
export const updateSelectedAddress = createAction<AddressInfo>('deliveryInfo/updateSelectedAddress')
